import "./index.css";
import { Spinner } from "./components/Spinner";
import { TorusPage } from "./pages/Torus";
import { DentistPage } from "./pages/Dentist";

export function App() {
  const page =
    location.pathname === "/dentist" ? <DentistPage /> : <TorusPage />;

  return (
    <>
      <div className="loader">
        <Spinner />
      </div>
      {page}
    </>
  );
}

export default App;
